import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

const publicApi = axios.create({
  baseURL: `${API_URL}/public`,
  withCredentials: false,
});

// Add a response interceptor to handle 401 errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      // Redirect to home/login
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export const franchiseAPI = {
  getAll: () => api.get('/franchises'),
  create: (data) => api.post('/franchises', data),
};

export const productAPI = {
  create: (formData) => api.post("/products", formData, { headers: { "Content-Type": "multipart/form-data" } }),
  getAll: () => api.get('/products'),
  update: (id, formData) => api.put(`/products/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } }),
  delete: (id) => api.delete(`/products/${id}`),
  search: (search) => api.get(`/products/search?search=${encodeURIComponent(search || '')}`),
  getImageUrl: (path) => `${API_URL}/images/${path.replace(/\\/g, "/")}`,
};

export const customerAPI = {
  create: (data) => api.post('/customers', data),
  get: (page, pageSize, search) => api.get(`/customers?page=${page}&page_size=${pageSize}&search=${encodeURIComponent(search || '')}`),
  getAll: () => api.get('/customers/all'),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: (id) => api.delete(`/customers/${id}`),
  search: (search) => api.get(`/customers?search=${encodeURIComponent(search || '')}&page=1&page_size=10`),
};

export const salesAPI = {
  create: (data) => api.post('/sales', data),
  get: (params) => api.get('/sales', { params }),
  update: (id, data) => api.put(`/sales/${id}`, data),
  delete: (id) => api.delete(`/sales/${id}`),
};

export const expenseAPI = {
  create: (data) => api.post('/expenses', data),
  get: (params) => api.get('/expenses', { params }),
  update: (id, data) => api.put(`/expenses/${id}`, data),
  delete: (id) => api.delete(`/expenses/${id}`),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
};

export const deliveryAPI = {
  updateStatus: (id, status) => api.put(`/deliveries/${id}`, { sale_id: id, status }),
};

export const inventoryAPI = {
  update: (data) => api.post('/inventory/update', data),
  getLogs: (productId) => api.get(`/inventory/logs?product_id=${productId}`)
};

export const userAPI = {
  getAll: () => api.get('/users'),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
};

export const metaAPI = {
  getProductCategories: () => api.get('/meta/product-categories'),
  getPaymentStatuses: () => api.get('/meta/payment-statuses'),
  getDeliveryStatuses: () => api.get('/meta/delivery-statuses'),
  getPaymentMethods: () => api.get('/meta/payment-methods'),
  getExpenseCategories: () => api.get('/meta/expense-categories'),
  getUserRoles: () => api.get('/meta/user-roles'),
};

export default api;